import { render, staticRenderFns } from "./maintainList.vue?vue&type=template&id=b85c2a70&scoped=true"
import script from "./maintainList.vue?vue&type=script&lang=js"
export * from "./maintainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c2a70",
  null
  
)

export default component.exports